import { formatBool } from '@/utils/shared';
import { presentNumberToCurrencyTable } from '@/services/formatter_services/currency-formatter';
import dateFormatter from "@/services/formatter_services/date-formatter";
import TRUNCATE_UNITS from '@/utils/enum/TRUNCATE_UNITS';
import dateService from '@/services/date-service';
//enum
import FORMAT_EXCEL_EXPORT_TYPE_ENUM from '@/services/formatter_services/enums/FORMAT_EXCEL_EXPORT_TYPE_ENUM'

const FIRST_DAY_OF_CURRENT_YEAR = dateService.getFirstDayOfMonth(new Date().getFullYear(), 0);
const LAST_DAY_OF_CURRENT_YEAR = dateService.getLastDayOfMonth(new Date().getFullYear(), 11)

const REPORT_WIDGETS = Object.freeze({
  ABSENT_REPORT_WIDGETS: [
    {
      id: 'absentReport',
      path: 'reports/absentevaluation',
      headers: [
        {
          text: 'Dashboard.widgets.absentReport.headers.day',
          value: 'day'
        },
        { text: 'Common.employee', value: 'employee' },
        {
          text: 'Dashboard.widgets.absentReport.headers.personnelNumber',
          value: 'personnelNumber',
          truncateUnit: TRUNCATE_UNITS.STRING,
          truncateAfter: 30
        },
        {
          text: 'Common.type',
          value: 'attendanceType'
        },
        {
          text: 'Dashboard.widgets.absentReport.headers.workingHoursSum',
          value: 'workingHoursSum'
        },
        {
          text: 'Dashboard.widgets.absentReport.headers.department',
          value: 'department'
        },
        { text: 'Dashboard.widgets.absentReport.headers.group', value: 'group' }
      ],
      type: 'TABLE',
      moduleId: 'absentReport',
      withRouterActionLink: false
    }
  ],
  ANNIVERSARY_REPORT_WIDGETS: [
    {
      id: 'anniversary',
      path: 'reports/anniversaryreport',
      defaultFilter: {
        fromDate: FIRST_DAY_OF_CURRENT_YEAR,
        untilDate: LAST_DAY_OF_CURRENT_YEAR,
      },
      headers: [
        { text: 'Common.type', value: 'type' },
        { text: 'Dashboard.widgets.anniversary.headers.jubilee', value: 'round' },
        { text: 'Dashboard.widgets.anniversary.headers.person', value: 'person' },
        {
          text: 'Common.date',
          value: 'date',
          presentWith: dateFormatter.formatDateToLocaleDateStringNoTime
        }
      ],
      type: 'TABLE',
      moduleId: 'anniversary',
      withRouterActionLink: false
    }
  ],
  EMPLOYEE_REPORT_WIDGETS: [
    {
      id: 'employeeReport',
      path: 'reports/monthly-hours',
      headers: [
        {
          text: 'Dashboard.widgets.employeeReport.headers.projectNumber',
          value: 'projectNumber'
        },
        { text: 'Common.employee', value: 'employee' },
        {
          text: 'Dashboard.widgets.employeeReport.headers.personnelNumber',
          value: 'personnelNumber',
          truncateUnit: TRUNCATE_UNITS.STRING,
          truncateAfter: 30
        },
        {
          text: 'Dashboard.widgets.employeeReport.headers.department',
          value: 'department'
        },
        {
          text: 'Dashboard.widgets.employeeReport.headers.occupationGroup',
          value: 'occupationGroup',
          type: FORMAT_EXCEL_EXPORT_TYPE_ENUM.NUMBER,
          format: '0',
        },
        {
          text: 'Dashboard.widgets.employeeReport.headers.productive',
          value: 'productive',
          presentWith: formatBool
        },
        {
          text: 'Dashboard.widgets.employeeReport.headers.workingTime',
          value: 'workingTime'
        }
      ],
      type: 'TABLE',
      moduleId: 'employeeReport',
      withRouterActionLink: false
    }
  ],
  OCC_REPORT_WIDGETS: [
    {
      id: 'occReport',
      path: 'reports/monthly-occ-group',
      defaultFilter: {
        from: new Date().getFullYear()+'-01-01',
        until: new Date().getFullYear()+'-12-31',
      },
      headers: [
        { text: 'Dashboard.widgets.occReport.headers.hours', value: 'hours' },
        { text: 'Common.label', value: 'label' },
        {
          text: 'Dashboard.widgets.occReport.headers.isProductive',
          value: 'isProductive',
          presentWith: formatBool
        }
      ],
      type: 'TABLE',
      moduleId: 'occGroupReport',
      withRouterActionLink: false
    }
  ],
  PROJECT_BUDGET_REPORT_WIDGET: [
    {
      id: 'projectBudgetReport',
      path: 'reports/project-budget',
      headers: [
        { text: 'Common.label', value: 'label' },
        { text: 'Common.company', value: 'companyName' },
        { text: 'Common.status', value: 'status' },
        {
          text: 'Common.start',
          value: 'startDate',
          presentWith: dateFormatter.formatDateToLocaleDateStringNoTime
        },
        {
          text: 'Common.end',
          value: 'endDate',
          presentWith: dateFormatter.formatDateToLocaleDateStringNoTime
        },
        {
          text: 'Dashboard.widgets.projectBudgetReport.headers.isProductive',
          value: 'isProductive',
          presentWith: formatBool
        }
      ],
      type: 'TABLE',
      moduleId: 'projectBudgetReport',
      withRouterActionLink: true
    }
  ],
  REPORT_STOCK_WIDGETS: [
    {
      id: 'productView',
      path: 'reports/stock',
      headers: [
        { text: 'Common.matchcode', value: 'productMatchCode' },
        { text: 'Common.product', value: 'product' },
        {
          text: 'Dashboard.widgets.productView.headers.deviceSerialNumber',
          value: 'deviceSerialNumber'
        },
        { text: 'Common.amount', value: 'amount' },
        {
          text: 'Dashboard.widgets.productView.headers.productUnit',
          value: 'productUnit'
        },
        {
          text: 'Dashboard.widgets.productView.headers.productUnitSymbol',
          value: 'productUnitSymbol'
        },
        {
          text: 'Common.storageElement',
          value: 'storageElement'
        }
      ],
      type: 'TABLE',
      moduleId: 'stockReport',
      withRouterActionLink: false
    }
  ],
  SALE_STATISTICS_REPORT: [
    {
      id: 'saleStatisticView',
      path: 'reports/sales-statistics',
      headers: [
        { text: 'Common.customer', value: 'customer' },
        { text: 'Common.project', value: 'project' },
        {
          text: 'Dashboard.widgets.saleStatisticView.headers.projectType',
          value: 'projectType'
        },
        { text: 'Common.net', value: 'netAmount', presentWith: presentNumberToCurrencyTable },
        {
          text: 'Common.gross',
          value: 'grossAmount',
          presentWith: presentNumberToCurrencyTable,
          alignValue: 'right',
        },
      ],
      type: 'TABLE',
      moduleId: 'salesStatisticsReport',
      withRouterActionLink: false,
      defaultFilter: {
          accountingMode: "sales",
          customergroup: true
      }
    },
    {
      id: 'saleStatisticNet',
      moduleId: 'salesStatisticsReport',
      path: 'reports/sales-statistics',
      type: 'CHART',
      getData: response => ({items: response.data.data}),
      defaultChartType: 'PIE',
      metric: 'netAmount',
      legendLabel: 'customer',
      mapSuffix: presentNumberToCurrencyTable,
      suffix: 'netAmount',
      defaultFilter: {
        accountingMode: "sales",
        customergroup: true
      }
    },
    {
      id: 'saleStatisticGross',
      moduleId: 'salesStatisticsReport',
      path: 'reports/sales-statistics',
      type: 'CHART',
      getData: response => ({items: response.data.data}),
      defaultChartType: 'PIE',
      metric: 'grossAmount',
      legendLabel: 'customer',
      mapSuffix: presentNumberToCurrencyTable,
      suffix: 'grossAmount',
      defaultFilter: {
        accountingMode: "sales",
        customergroup: true
      }
    },
  ]
});

export default REPORT_WIDGETS;
